
<div class="table-container">
  <div class="my-2">
    <button id="table-btn-add" *ngIf="allowNewRows" class="btn btn-primary mr-2" (click)="addNewRows()">{{appService.CoreCommonLiterals.Add}}</button>
  </div>
  
  <div class="row my-2">
    <div class="col-12">
      <form class="searchbar my-3" *ngIf="!disableFilter" autocomplete="off" novalidate (submit)="$event.preventDefault();">
        <div class="input-group">
          <input #search
            customFocus
            class="search form-control"
            type="text"
            name="filter"
            [id]="'filter'+fileNumber"
            [placeholder]="appService.CoreCommonLiterals.ButtonSearch+'...'"
            (keyup)="onSearchChange()"
            [(ngModel)]="searchText"
            tabindex="-1">
          <span class="input-group-append" *ngIf="searchText">
            <button id="table-preferences" class="btn btn-default btn-secondary" (click)="cleanFilter()"><i class="fa fa-times"></i></button>
          </span>
        </div>
      </form>
    </div>
  </div>

  <div class="table-container">
    <div class="table-responsive">
      <table class="table tablestuff">
        <thead>
          <tr>
            <th *ngIf="enableRadioSelected"></th>
            <th *ngIf="enableCheckSelected && paginatedData?.length" class="px-0 pb-1">
              <div class="position-relative d-inline-block text-right" dropdown>
                <button id="btn-filter-list" class="btn btn-outline-secondary dropdown-toggle d-flex align-items-center" dropdownToggle type="button">
                  <div class="custom-control custom-checkbox mr-1 d-inline-block" [tooltip]="!selectAllElements ? 'Seleccionar todos' : 'Desmarcar todos'" >
                    <input type="checkbox" class="custom-control-input" name="checkAll" id="checkAll" [(ngModel)]="selectAllElements" (change)="toggleSelectAll($event)">
                    <label class="custom-control-label" for="checkAll"></label>
                  </div>
                </button>
                <ul *dropdownMenu class="dropdown-menu dropdown-menu-left dropdown-menu-lg-right" role="menu">
                  <li role="menuitem" [id]="'filter-menu-list-'+i" *ngFor="let item of menuButtonList; let i = index;" >
                    <a type="button" class="dropdown-item" [id]="item.value" (click)="dropdownMenuAction($event, item)"  style="text-transform: none;">
                      <i [attr.class]="'mr-2 fa-solid ' + item?.icon" *ngIf="item?.icon"></i>{{item.label}}
                    </a>
                  </li>
                </ul>
              </div>
            </th>
            <th *ngIf="enableWarningTooltip"></th>
            <th *ngFor="let col of data?.Columns;let i = index" 
            class="report-cell"
            [attr.width]="col.WidthPixels"
            style="cursor: pointer;"
            (click)="sortTable(i)"
            >
              <div class="report-cell-content d-flex align-items-center" [attr.align]="(col.Alignment === alignTypes.Center) ? 'center' : (col.Alignment === alignTypes.Right) ? 'right' : 'left'">
                {{col.Title}}
                <div *ngIf="i === sort.column" class="d-inline-block">
                  <i class="fa-solid fa-caret-up" *ngIf="sort.direction === 1" style="font-size: 16px;"></i>
                  <i class="fa-solid fa-caret-down" *ngIf="sort.direction === 2" style="font-size: 16px;"></i>
                  <i *ngIf="sort.direction === null">&nbsp;</i>
                </div>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of paginatedData; let i = index" 
          [ngStyle]="row.RowStyle" 
          [class.selected-row]="selectedRow === row.ElementId" 
          [ngClass]="{'unmarked-checkbox': enableCheckSelected 
          && !row.Enabled, 'marked-checkbox': enableCheckSelected 
          && row.Enabled, 'hasEvent': enableCheckSelected && row.Enabled
          && row['Events'].EventID, 'noneEvent': enableCheckSelected 
          && row.Enabled && !row['Events'].EventID }"> 
            <td *ngIf="enableRadioSelected">
              <div class="form-check" style="padding: 0 .8rem;">
                <input 
                  class="form-check-input" 
                  type="radio" 
                  name="rowSelection" 
                  [id]="'radio-'+row.ElementId" 
                  [value]="row.ElementId" 
                  (change)="onRowSelect(row.ElementId)" 
                  [checked]="selectedRow === row.ElementId">
                <label class="form-check-label" [for]="'radio-'+ row.ElementId"></label>
              </div>
            </td>
            <td *ngIf="enableCheckSelected">
              <div class="custom-control custom-checkbox" [tooltip]="'Seleccionar'" >
                <input type="checkbox" class="custom-control-input" [id]="'table-check-'+i" [name]="'table-check-'+i" [(ngModel)]="row.Enabled" (change)="onCheckboxChange()">
                <label class="custom-control-label" [for]="'table-check-'+i"></label>
              </div>
            </td>
            <td *ngIf="enableWarningTooltip">
              <span class="ml-2" triggers="click hover" [tooltip]="warningTooltipText" *ngIf="row.RowType ==='tooltip'">
                <i class="fa-solid fa-info-circle text-warning"></i>
              </span>
            </td>

            <td *ngFor="let col of data?.Columns" 
            [ngClass]="{'text-right': col.Type == 'actions'}" 
            [attr.align]="(col.Alignment === alignTypes.Center) ? 'center' : (col.Alignment === alignTypes.Right) ? 'right' : 'left'" 
            (click)="enableRadioSelected ? onRowSelect(row.ElementId) : null"
            [ngStyle]="{'cursor': enableRadioSelected ? 'pointer': 'initial'}" 
            class="text-truncate"
            [ngStyle]="{'max-width': col.MaxWidthPixels +'px'}"
            [tooltip]=" col.MaxWidthPixels && row[col.Field]?.length > 20 ? row[col.Field] : null"
            >
              <ng-container [ngSwitch]="col.Type">
                <ng-container *ngSwitchCase="'text'">
                  {{ row[col.Field] }}
                </ng-container>

                <ng-container *ngSwitchCase="'dynamic'">
                  <ng-container [ngSwitch]="row[col.Field]?.Type">
                    <ng-container *ngSwitchCase="'text'">
                      <p class="mb-0">{{ row[col.Field].Text }}</p>
                    </ng-container>

                    <ng-container *ngSwitchCase="'checkbox'">
                      <div class="custom-control custom-checkbox d-inline-flex align-items-center">
                        <input 
                          class="custom-control-input" 
                          type="checkbox" 
                          [id]="'checkbox-event-'+row.ElementId" 
                          [(ngModel)]="row[col.Field].Checked" 
                          (change)="row[col.Field].Action(row);" />
                        <label 
                          [for]="'checkbox-event-'+row.ElementId" 
                          class="custom-control-label ml-2">
                          {{ row[col.Field].Text }}
                        </label>
                      </div>
                    </ng-container>
                    
                    <ng-container *ngSwitchCase="'icon-text'">
                      <span>{{ row[col.Field].Text }}</span>
                      <ng-container *ngFor="let icon of row[col.Field].Icons">
                        <button class="btn btn-link p-0 mx-1" 
                          (click)="icon.Action(row)" 
                          [tooltip]="icon.Tooltip">
                          <i class="fa" [ngClass]="icon.Icon"></i>
                        </button>
                      </ng-container>
                    </ng-container>
                  </ng-container>
                </ng-container>
  
                <ng-container *ngSwitchCase="'actions'">
                  <ng-container *ngFor="let action of row[col.Field]">
                    <button class="btn btn-link p-0 mx-1" 
                        (click)="action.Action(row);" 
                        [tooltip]="action.Tooltip">
                      <i class="fa" [ngClass]="action.Icon"></i>
                    </button>
                  </ng-container>
                </ng-container>
              </ng-container>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="not-found-message text-center mt-5" *ngIf="data && paginatedData && paginatedData?.length === 0 && !loadData">
      <i class="fa fa-file-alt text-primary fa-4x"></i>
      <p class="h5 text-muted my-2">{{ appService.CoreCommonLiterals.NoDataFound}}</p>
    </div>
  </div>

  <div class="text-center d-flex align-items-center w-100 justify-content-center" *ngIf="paginatedData === null || loadData" style="min-height: 100px;">
    <i class="fas fa-circle-notch fa-spin fa-2x"></i>
  </div>
  
  <div class="d-flex justify-content-end mt-4" >
    <div class="d-flex mr-3 text-right align-items-center" *ngIf="enableRowsPerPage && filteredData?.length >= itemsPerPageOptions[0]">
      <label for="itemsPerPage" class="mb-0 mr-2">Filas por página:</label>
      <select id="itemsPerPage" [(ngModel)]="itemsPerPage" (change)="onItemsPerPageChange($event)">
        <option *ngFor="let option of itemsPerPageOptions" [value]="option">{{ option }}</option>
      </select>
    </div>
    <nav aria-label="Page navigation" *ngIf="enablePagination" class="d-flex align-items-center">
        <button
        id="reports-btn-start"
        [disabled]="filteredData?.length < itemsPerPage || currentPage == 1"
        type="button"
        class="btn btn-secondary text-nowrap mr-2 mb-2 mb-sm-0"
        (click)="onPageChange(1)">
        <span>&lsaquo;</span> {{appService.CoreCommonLiterals.FirstPage }}
      </button>
      <button
        id="reports-btn-previous"
        [disabled]="filteredData?.length < itemsPerPage || currentPage == 1"
        type="button"
        class="btn btn-secondary text-nowrap mr-2 mb-2 mb-sm-0"
        (click)="onPageChange(currentPage - 1)">
        <span>&laquo;</span> {{appService.CoreCommonLiterals.PreviousPage }}
      </button>
      <span class="mx-2 text-nowrap mb-2 mb-sm-0" *ngIf="totalPages > 1">
        {{ currentPage }} / {{ totalPages }}
      </span>
      <button
        id="reports-btn-next"
        [disabled]="filteredData?.length < itemsPerPage || currentPage == totalPages"
        type="button"
        class="btn btn-secondary mx-2 text-nowrap mb-2 mb-sm-0"
        (click)="onPageChange(currentPage + 1)">
        {{ appService.CoreCommonLiterals.NextPage }} <span>&raquo;</span>
      </button>
      <button
        id="reports-btn-last"
        type="button"
        [disabled]="filteredData?.length < itemsPerPage || currentPage == totalPages"
        class="btn btn-secondary mx-2 text-nowrap mb-2 mb-sm-0"
        (click)="onPageChange(totalPages)">
        {{ appService.CoreCommonLiterals.LastPage }} <span>&rsaquo;</span>
      </button>
      <!-- <span class="mx-2 text-nowrap" *ngIf="showTotalRowCount">
        {{ appService.CoreCommonLiterals.TotalRowCount + ': ' + _totalRowCount }}
      </span> -->
    </nav>
</div>